// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 15.5C11 14.4518 11.6444 14 12 14C12.3556 14 13 14.4518 13 15.5C13 16.5482 12.3556 17 12 17C11.6444 17 11 16.5482 11 15.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM9 12V8H7V12H9ZM17 12V8H15V12H17ZM12 12C10.1464 12 9 13.7868 9 15.5C9 17.2132 10.1464 19 12 19C13.8536 19 15 17.2132 15 15.5C15 13.7868 13.8536 12 12 12Z"}}]};

const Surprised1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'surprised-1-filled',
    ref,
    icon: element,
  },
));

Surprised1FilledIcon.displayName = 'Surprised1FilledIcon';

export default Surprised1FilledIcon;
